import $ from 'jquery';

let id = 0,
	Q = {},
	prevent_abort = false;

$(document).ajaxSend(function(e, jqx){
	jqx._id = ++id;
	Q[jqx._id] = jqx;
});

$(document).ajaxComplete(function(e, jqx){
	delete Q[jqx._id];
});

$.ajaxQ = {
	abortAll: function(){
		if(prevent_abort){
			return false;
		}

		let requests = [];

		$.each(Q, function(i, jqx){
			requests.push(jqx._id);
			jqx.abort();
		});

		return true;
	},
	preventAbort: function(){
		prevent_abort = true;
	},
	enableAbord: function(){
		prevent_abort = false;
	}
};

export default $.ajaxQ;